export default __webpack_public_path__ + "static/mockup1_1_inspection_settings-b33f5f8acea3a78e22edd3977fcea715.png";